/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Membership_Freeze_Weeks_OtherInputs */

const fr_membership_freeze_weeks_other = /** @type {(inputs: Membership_Freeze_Weeks_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} semaines`)
};

/**

* @param {Membership_Freeze_Weeks_OtherInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_weeks_other = /** @type {((inputs: Membership_Freeze_Weeks_OtherInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Weeks_OtherInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_weeks_other(inputs)
});